import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps {
    label: React.ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
    error?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, error }) => {
    return (
        <div className="flex flex-col gap-1">
            <div
                className="flex items-center gap-3 cursor-pointer group"
                onClick={() => onChange(!checked)}
            >
                <div className={`
          w-5 h-5 rounded-[6px] border flex items-center justify-center transition-all duration-200 shadow-sm flex-shrink-0
          ${checked
                        ? 'bg-[#015FA6] border-[#015FA6] scale-100'
                        : 'bg-white border-[#CFD9E0] group-hover:border-[#015FA6] group-hover:bg-[#F0F7FF]'
                    }
          ${error ? 'border-red-500' : ''}
        `}>
                    <Check
                        size={14}
                        className={`text-white transition-all duration-200 ${checked ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}`}
                        strokeWidth={3}
                    />
                </div>
                <span className="text-[#015FA6] text-sm sm:text-base font-['Manrope'] select-none font-medium opacity-90 group-hover:opacity-100 transition-opacity">
                    {label}
                </span>
            </div>
            {error && (
                <p className="text-red-500 text-xs ml-8 font-['Manrope']">
                    {error}
                </p>
            )}
        </div>
    );
};

export default Checkbox;
